window.track = function(category, action, label) {
  if(typeof(window.gtag) == "undefined") return;

  window.gtag("event", action, {
    "event_category": category,
    "event_label": label,
  })
}
